import React from 'react'
import Header from './Header'
import Menu from './Menu'
import bg from './bg.jpg'

import './home.css'

export default () => (
  <main>
    <Header />
    <Menu />
    <div>
      <img src={bg} className='bg' />
    </div>
  </main>
)
